import { render, staticRenderFns } from "./CandidateRow.vue?vue&type=template&id=199625b4"
import script from "./CandidateRow.vue?vue&type=script&lang=js"
export * from "./CandidateRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports